import { t } from "@travily/i18n";
import { ConfirmDialog } from "@ui/components/ConfirmDialog";

export interface CurrencyChangeConfirmModalProps {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  /** Confirm — apply the currency change and re-price. */
  onConfirm: () => void;
  isPending?: boolean;
  /** How many existing paid listings the change will re-price. */
  count: number;
  fromCurrency: string;
  toCurrency: string;
}

/**
 * Confirms a selling-currency change that re-prices the seller's existing paid
 * drafts, so it's a knowing choice rather than a silent one. Shown only when the
 * change actually affects listings; the caller reverts the selection on dismiss.
 */
export function CurrencyChangeConfirmModal({
  isOpen,
  onOpenChange,
  onConfirm,
  isPending = false,
  count,
  fromCurrency,
  toCurrency,
}: CurrencyChangeConfirmModalProps) {
  return (
    <ConfirmDialog
      cancelLabel={t("components.views.shared.currency_change_confirm_modal.keep", { currency: fromCurrency })}
      confirmLabel={t("components.views.shared.currency_change_confirm_modal.change", { currency: toCurrency })}
      description={t("components.views.shared.currency_change_confirm_modal.body", {
        count,
        from: fromCurrency,
        to: toCurrency,
      })}
      isPending={isPending}
      onConfirm={onConfirm}
      onOpenChange={onOpenChange}
      isOpen={isOpen}
      title={t("components.views.shared.currency_change_confirm_modal.title")}
    />
  );
}
